import {connect} from '@modifi/redux'
import {compose} from 'ramda'

import {
  aFetchShipmentDetails,
  aClearShipmentDetails,
  selectShipmentDetails,
  selectShipmentDetailsAreLoading,
  selectShipmentDetailsHasError,
} from '../../../data/shipment-details'
import ShipmentTrackingDetails, {ShipmentTrackingDetailsProps} from './ShipmentTrackingDetails'
import {withSuspense} from '../../../hoc'

const mapStateToProps = (
  state: Record<string, any>
): Pick<ShipmentTrackingDetailsProps, 'shipmentDetails' | 'hasError' | 'isLoading'> => ({
  shipmentDetails: selectShipmentDetails(state),
  hasError: selectShipmentDetailsHasError(state),
  isLoading: selectShipmentDetailsAreLoading(state),
})

const mapDispatchToProps = {
  fetchDetails: aFetchShipmentDetails,
  clearDetails: aClearShipmentDetails,
}

export default compose(
  withSuspense(false),
  connect(mapStateToProps, mapDispatchToProps)
)(ShipmentTrackingDetails)
